


















import Vue from "vue";
import Component from "vue-class-component";
import Header from "./components/common/Header.vue";
import SideBar from "./components/common/Sidebar.vue";
import AdminSidebar from "./components/common/AdminSidebar.vue";
import Footer from "./components/common/Footer.vue";
import ContactButton from "./components/common/ContactButton.vue";

@Component({
  components: {
    Header,
    SideBar,
    Footer,
    AdminSidebar,
    ContactButton
  }
})
export default class App extends Vue {
  draw = false;

  private openSideBar(): void {
    this.draw = !this.draw;
  }

  private get drawer(): boolean {
    return this.draw;
  }
}
